// External Modules
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LeafletModule } from '@asymmetrik/ngx-leaflet';

// Internal Modules
import { DatePickerModule } from 'src/app/modules/date-picker/date-picker.module';

// Components
import { NgxMapComponent } from './ngx-map.component';


@NgModule({
  declarations: [
    NgxMapComponent
  ],
  imports: [
    CommonModule,
    LeafletModule,
    DatePickerModule
  ],
  exports: [NgxMapComponent]
})
export class NgxMapModule { }
